import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, HostListener, Injector, OnDestroy, OnInit, Output, Renderer2, TemplateRef, ViewChild, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { Validators } from '@angular/forms';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { ButtonMessageActionItem } from '@trendbuild/trend-z-api';
import { AbstractComponent, AlertModalComponent, Attendance, AttendanceCopilotInsightService, AttendanceService, AttendanceStatusEnum, AttendanceWhisper, AttendanceWhisperService, AttendanceWhisperSignal, AudioService, BottomSheetResponseFastComponent, buildAgentSignature, CallPhoneComponent, Channel, ChannelService, ChannelTypeEnum, ConfirmationComponent, Contact, ContactListModalComponent, ContactService, ConversationWindowStateEnum, ConversationWindowUtil, CopilotComposeBridgeService, ExportService, FirebaseService, GoogleMapsComponent, GooglePlaceType, isRCSConversational, LoadMessageService, Message, MessageFocus, MessageHelper, MessageScheduled, MessageService, MessageTypeEnum, MetadataAttedance, MetadataMessage, ModalResponseFastComponent, ModalResponseFastData, Pager, PreviewMediaComponent, ResponseService, SettingsModule, SocketService, splitAgentSignature, TabService, Tabulation, TabulationStatus, Traduct, UploadTypeEnum, UserService, UtilHelper, WHISPER_SOCKET_EVENT, ZAPICallManagerService } from 'lib-trend-core';
import { catchError, concatMap, firstValueFrom, forkJoin, Observable, of, Subject, takeUntil, tap, throwError } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { AttendanceHistoryComponent, AttendanceHistoryData } from '../../attendance-history/attendance-history.component';
import { TimelineAttendanceComponent } from '../../timeline-attendance/timeline-attendance.component';
import { AiAssistantActivatorSelectorComponent } from '../attendance-panel-components/ai-assistant-activator-selector/ai-assistant-activator-selector.component';
import { AssignedUserComponent } from '../attendance-panel-components/assigned-user/assigned-user.component';
import { ChatHeaderActionId, conversationWindowOf } from '../attendance-panel-components/chat-header/chat-header.actions';
import { ChatMessageScheduleComponent } from '../attendance-panel-components/chat/chat-messages/chat-message-schedule/chat-message-schedule';
import { ChatMessageScheduleListComponent } from '../attendance-panel-components/chat/chat-messages/chat-message-schedule/chat-message-schedule-list/chat-message-schedule-list';
import { ChatTemplateScheduleComponent } from '../attendance-panel-components/chat/chat-messages/chat-template-schedule/chat-template-schedule.component';
import { ChatSelectTemplateComponent } from '../attendance-panel-components/chat/chat-select-template/chat-select-template.component';
import { ConfirmationCloseAttendanceComponent } from '../attendance-panel-components/confirmation-close-attendance/confirmation-close-attendance.component';
import { CrmIntegrationsComponent } from '../attendance-panel-components/crm-integrations/crm-integrations.component';
import { SendButtonsAttendanceComponent } from '../attendance-panel-components/send-buttons-attendance/send-buttons-attendance.component';
import { bumpCopilotGateMessageCount, clearFocusMessage, getAttendance, getAttendances, getMessages, getNotes, getWhispers, openCloseSidebarRight, removeWhisperPending, setAttendance, setCopilotGateMessageCount } from '../state/actions';
import { AppState, PagerParamsState } from '../state/app.state';
import { attendanceSelector, focusMessageSelector, hasPipedriveIntegrationSelector, messagesSelector, openCloseSidebarRightSelector, pagerParamsSelector, settingsModulesSelector, simpleTabulationsSelector, whisperPendingSelector, whispersSelector } from '../state/selectors';



/** Untranslated key of the Hybrid window-closed refusal (SPEC-2026-10-whatsapp-hybrid-channel RF-11). */
const HYBRID_WINDOW_CLOSED_ERROR_KEY = 'errors.message.hybridWindowClosed';

@Component({
    selector: 'attendance-panel-chat-component',
    templateUrl: './attendance-panel-chat.v2.component.html',
    // templateUrl: './attendance-panel-chat.component.html',
    styleUrls: ['./attendance-panel-chat.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AttendancePanelChatComponent extends AbstractComponent implements OnInit, OnDestroy {

  @ViewChild('transferModal') transferModal: TemplateRef<any>;
  @ViewChild('inputImagefile', { static: false }) inputImagefile: ElementRef<HTMLInputElement>;
  @ViewChild('inputVideofile', { static: false }) inputVideofile: ElementRef<HTMLInputElement>;
  @ViewChild('inputDocfile', { static: false }) inputDocfile: ElementRef<HTMLInputElement>;
  @ViewChild('inputAudiofile', { static: false }) inputAudiofile: ElementRef<HTMLInputElement>;
  @ViewChild('messageContainer') messageContainer: ElementRef<HTMLDivElement>;
  @ViewChild('audioContainer', { static: false }) audioContainer!: ElementRef;
  @ViewChild("emojiContainer", { static: false, read: ElementRef }) emojiContainer!: ElementRef;
  @ViewChild('ta', { static: false }) messageTextArea: ElementRef<HTMLTextAreaElement>;
  @Output() collapseEmitted = new EventEmitter();

  readonly attendance$: Observable<Attendance> = this.store.select(attendanceSelector);
  readonly messages$: Observable<Pager<Message>> = this.store.select(messagesSelector);
  readonly focusMessage$: Observable<MessageFocus | null> = this.store.select(focusMessageSelector);
  readonly pagerParams$: Observable<PagerParamsState> = this.store.select(pagerParamsSelector);
  readonly sidebarRight$: Observable<boolean> = this.store.select(openCloseSidebarRightSelector);
  readonly hasPipedriveIntegration$: Observable<boolean> = this.store.select(hasPipedriveIntegrationSelector);
  readonly settingsModules$: Observable<Array<SettingsModule>> = this.store.select(settingsModulesSelector);
  readonly whispers$: Observable<Array<AttendanceWhisper>> = this.store.select(whispersSelector);
  readonly whisperPending$: Observable<Array<string>> = this.store.select(whisperPendingSelector);
  readonly listTabulations$: Observable<Array<Tabulation>> = this.store.select(simpleTabulationsSelector);

  pager: Pager<MessageScheduled> = new Pager<MessageScheduled>({ perPage: 7 });
  attendance: Attendance;

  public messages: Array<Message> = new Array<Message>();
  public pagerMessage: Pager<Message> = new Pager<Message>({ perPage: 10 });

  sidebarRight: boolean = false;
  isInputFocused: boolean = false;
  showContainerEmoji: boolean = false;
  integration: boolean = false;

  textEmoji!: any;
  translator!: Traduct;
  dialogRef: MatDialogRef<any>;
  pagerParamsState: PagerParamsState;

  searchOpen = false;
  searchText = '';
  searchResults: { index: number; element: HTMLElement }[] = [];
  currentSearchResultIndex = -1;
  totalSearchResults = 0;


  private pendingScrollMessageId: string | null = null;
  // Message picked from the inbox search, scrolled to once its attendance's first page is loaded.
  private pendingFocus: MessageFocus | null = null;
  private scrollLoadAttempts = 0;
  private scrollLoadHighWater = 0;
  private scrollInfoShown = false;
  private highlightedElement: HTMLElement | null = null;
  private readonly maxScrollLoadAttempts = 40;
  private deepLinkScrollRequest: { idAttendance: string; idMessage: string } | null = null;
  private readonly routeDestroy$ = new Subject<void>();

  isRecording!: boolean;
  stream!: MediaStream;
  recorder!: MediaRecorder;
  audioChunks: Blob[] = [];
  isCancel!: boolean;
  audioUrl!: string | null;
  isPreview: boolean = false;
  audioFile!: File | undefined;
  recordingTime: number = 0;
  intervalId!: any;
  isLoading: boolean = false;
  isLoadingExport: boolean = false;

  isWaitingMessageScheduled: boolean = false;
  lastMessageDate: Date;
  dateFormatted!: string;

  selectedIndexTab: number = 0;
  showEmpty: boolean = false;

  statusInProgress: AttendanceStatusEnum = AttendanceStatusEnum.IN_PROGRESS;

  isMessageReplyed: boolean = false;
  messageReplyed!: Message;

  private clearTimeout
  private clickOutsideListener
  isMessageEdit: boolean = false;
  messageEdit: Message;
  // What the composer held before an edit took it over; given back when the edit ends.
  private draftBeforeEdit: string | null = null;
  conversation: Message[];

  activeIAModule: boolean = false;
  activeWavoipModule: boolean = false;

  // Whisper field state (SPEC-2026-09-attendance-whisper): its own field, never the customer composer.
  whisperFieldOpen: boolean = false;
  whisperReplyTo: AttendanceWhisper | null = null;
  whisperEditing: AttendanceWhisper | null = null;


  constructor(
    injector: Injector,
    private loadingMessage: LoadMessageService,
    private modalResponse: MatDialog,
    private store: Store<AppState>,
    private tabService: TabService,
    private audioService: AudioService,
    private modalUploadPreview: MatDialog,
    private modalAlert: MatDialog,
    public dialog: MatDialog,
    public messageService: MessageService,
    public userService: UserService,
    public contactService: ContactService,
    public channelService: ChannelService,
    private whisperService: AttendanceWhisperService,
    public attendanceService: AttendanceService,
    public socketService: SocketService,
    public firebaseService: FirebaseService,
    public responseService: ResponseService,
    private modalScheduleMessage: MatDialog,
    private modalScheduleMessageList: MatDialog,
    private modalSendContact: MatDialog,
    private modalSendLocation: MatDialog,
    private renderer: Renderer2,
    private bottomSheet: MatBottomSheet,
    private modalCallPhone: MatDialog,
    public exportService: ExportService,
    private eRef: ElementRef,
    private zapiCallManager: ZAPICallManagerService,
    private copilotComposeBridge: CopilotComposeBridgeService,
    private copilotInsight: AttendanceCopilotInsightService,
  ) {
    super(injector);
    this.translator = UtilHelper.getEmojiTranslator();
  }

  /** A message appended live counts for the Copilot gate and for the insight's "new messages" (RF-41). */
  private countMessageForCopilot(): void {
    this.store.dispatch(bumpCopilotGateMessageCount());
    this.copilotInsight.noteMessage();
  }

  // Dedicated teardown for the composer subscriptions (Copilot compose bridge and
  // auto-resize): kept separate from destroy$, which initComponent() fires on every
  // attendance switch and would silently kill them after the first switch.
  private readonly composerDestroy$ = new Subject<void>();

  waves: number[] = [];

  private readonly headerActions: Record<ChatHeaderActionId, () => void> = {
    template: () => this.selectTemplate(),
    transfer: () => this.openAssignedUserTransferModal(),
    whisper: () => this.toggleWhisperField(),
    pause: () => this.togglePause(),
    call: () => this.initCall(this.attendance),
    scheduled: () => this.openModalScheduledList(this.attendance),
    history: () => this.showDetailsAttendanceHitory(this.attendance),
    timeline: () => this.showTimelineAttendance(this.attendance),
    export: () => this.exportConversation(),
    ai: () => this.activeUnactiveAI(),
    crm: () => this.openDialogCrm(this.attendance),
    block: () => this.blockOrUnblock(this.attendance?.contact, this.attendance?.channel),
    close: () => this.confirmationCloseAttendance(),
    panel: () => this.toggleSidebar(),
    search: () => this.toggleSearch(),
    searchSubmit: () => this.searchMessages(),
    searchPrevious: () => this.previousSearchResult(),
    searchNext: () => this.nextSearchResult(),
    searchOlder: () => this.searchInMoreMessages(),
  };

  onHeaderAction(id: ChatHeaderActionId): void {
    this.headerActions[id]();
  }

  private ownsPaste(event: ClipboardEvent): boolean {
    const target = event.target as Node | null;
    if (target && this.eRef.nativeElement.contains(target)) return true;

    const focused = document.activeElement;
    return !focused || focused === document.body;
  }

  @HostListener('document:paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    if (!this.ownsPaste(event)) return;

    const items = event.clipboardData?.items;
    if (!items) return;

    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (item.type.indexOf('image') !== -1) {
        const file = item.getAsFile();
        if (file) {
          this.onSelectMedia('image', file);
          event.preventDefault();
          event.stopPropagation();
        }
      }
    }
  }

  ngOnInit(): void {
    this.setupForm();
    this.listenComposerResize();
    this.listenDeepLinkMessage();
    this.initComponent();
    this.listenCopilotSuggestions();
    this.generateWaves();

    this.intervalId = setInterval(() => {
      this.generateWaves();
    }, 200);
  }

  private listenComposerResize(): void {
    this.formGroup.get('message').valueChanges
      .pipe(takeUntil(this.composerDestroy$))
      .subscribe(() => this.autoResizeTextArea(this.messageTextArea?.nativeElement, 3));
  }

  // Inserts a Copilot reply suggestion into the message composer. Appends to any
  // text the agent already typed (never overwrites) so the suggestion is additive.
  private listenCopilotSuggestions(): void {
    this.copilotComposeBridge.composeText$
      .pipe(takeUntil(this.composerDestroy$))
      .subscribe((text: string) => {
        const control = this.formGroup?.get('message');
        if (!control) return;
        const current = (control.value ?? '').toString();
        control.setValue(current.trim() ? `${current}\n${text}` : text);
        control.markAsDirty();
      });
  }

  generateWaves() {
    this.waves = Array.from({ length: 80 }, () => +(Math.random().toFixed(2)));
  }

  override ngOnDestroy() {
    super.ngOnDestroy();
    this.destroy$.next();
    this.destroy$.complete();
    this.composerDestroy$.next();
    this.composerDestroy$.complete();
    this.routeDestroy$.next();
    this.routeDestroy$.complete();

    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  private initComponent() {
    this.attendance$.subscribe(attendance => {
      if (!attendance) return;

      const idCompany: unknown = attendance.company._id ? attendance.company._id : attendance.company;
      if (idCompany !== super.getIDCurrentCompany()) {
        this.alertService.info(this.t('attendance.chat.attendanceNotFoundInCompany', { company: super.getNameCompanyCurrentUser() }));
        return;
      }

      sessionStorage.removeItem('preview_audio');
      this.audioUrl = null;
      this.isLoading = false;
      if (this.attendance?._id !== attendance._id) {
        this.formGroup.reset('');
        this.isMessageReplyed = false;
        this.isMessageEdit = false;
        this.searchOpen = false;
        this.clearSearchComplete();
      }
      this.attendance = attendance;
      this.messages = [];
      this.pagerMessage = new Pager<Message>({ perPage: 25 });
      this.pendingScrollMessageId = null;
      if (this.pendingFocus?.attendanceId !== attendance._id) {
        this.pendingFocus = null;
      }
      this.clearJumpHighlight();
      this.armDeepLinkScroll(attendance._id);
      this.destroy$.next(); // clear all subscriptions of last attendances messages

      this.store.dispatch(getMessages({
        page: this.pagerMessage.page,
        perPage: this.pagerMessage.perPage,
        idAttendance: attendance._id, idCompany: super.getIDCurrentCompany()
      }));

      this.configSocket();

      this.closeWhisperField();
      this.store.dispatch(getWhispers({ idAttendance: attendance._id }));
      this.markWhisperSeen(attendance._id);

      // Get settings modules of channel to check if IA and Wavoip are active
      this.settingsModules$.subscribe((settingsModules: Array<SettingsModule>) => {
        const settingsModuleOfChannel: SettingsModule = settingsModules.find((settingsModule: SettingsModule) => settingsModule.channel?._id === this.attendance.channel._id);
        if (!!settingsModuleOfChannel) {
          this.activeIAModule = settingsModuleOfChannel.activeIAModule;
          this.activeWavoipModule = settingsModuleOfChannel.activeWavoipModule;
        }
      });

    });

    this.messages$.subscribe((pager: Pager<Message>) => {
      this.pagerMessage.page = pager.page;
      this.pagerMessage.perPage = pager.perPage;
      this.pagerMessage.previousPage = pager.previousPage;
      this.pagerMessage.total = pager.total;
      // Feed the copilot minimum-messages gate with the authoritative total. This is a
      // SEPARATE state field (not state.messages), so it never re-triggers this very
      // subscription — the real-time message list stays an optimistic local append.
      this.store.dispatch(setCopilotGateMessageCount({ count: pager.total }));
      this.pagerMessage.list = pager.page === 1 ? pager.list : [...this.pagerMessage.list, ...pager.list];
      if (this.pagerMessage.total > 0) {
        this.pagerMessage.list = [...this.pagerMessage.list].sort((a, b) => {
          const d1 = new Date(a.createdAt).getTime();
          const d2 = new Date(b.createdAt).getTime();
          return (d1 > d2) ? 1 : -1;
        });
      }

      this.messages = this.pagerMessage.list;
      this.loadingMessage.setLoadingMessage(false);
      if (pager.page === 1) {
        this.resolvePendingFocus();
      }

      // The list was re-sorted/collapsed: drop any active jump highlight so the
      // pulse can't outlive the DOM node it was applied to (track $index reuse).
      this.clearJumpHighlight();

      // A new page (or a newly arrived message) was rendered: if a reply jump is
      // pending, retry now that the target may be in the DOM.
      if (this.pendingScrollMessageId) {
        setTimeout(() => this.resolvePendingScroll(), 150);
      }
    });

    this.focusMessage$.subscribe(focus => {
      if (!focus) return;
      this.pendingFocus = focus;
      this.store.dispatch(clearFocusMessage());
      this.resolvePendingFocus();
    });

    this.sidebarRight$.subscribe(sidebarRight => {
      this.sidebarRight = sidebarRight;
    });

    this.pagerParams$.subscribe(pager => {
      this.pagerParamsState = pager;
    });

  }

  // Record audio
  private startRecording(idAttendance: string): void {
    if (this.isRecording) return;

    this.recordingTime = 0;
    this.intervalId = setInterval(() => {
      this.recordingTime++;
    }, 1000);

    navigator.mediaDevices.getUserMedia({ audio: true })
      .then((stream) => {
        this.isRecording = true;
        this.isCancel = false;
        this.stream = stream;
        this.recorder = new MediaRecorder(this.stream);
        this.audioChunks = [];

        this.recorder.ondataavailable = (event) => {
          if (!this.isCancel) {
            this.audioChunks.push(event.data);
          }
        };

        this.recorder.onstop = async () => {
          if (!this.isCancel) {
            const dateMilisecond = new Date().getTime();
            const audioBlob = new Blob(this.audioChunks, { type: 'audio/webm' });
            if (this.attendance.channel.type === ChannelTypeEnum.INSTAGRAM_API) {
              const filename: string = `${idAttendance}_audio_${dateMilisecond.toString()}.wav`;
              const newBlob = await this.audioService.convertWebMToWav(audioBlob);
              this.audioFile = new File([newBlob], filename, { type: 'audio/wav' });
              await this.uploadAudioToFirebase(filename, idAttendance);
            } else if (this.attendance.channel.type === ChannelTypeEnum.Z_API) {
              const filename: string = `${idAttendance}_audio_${dateMilisecond.toString()}.mp3`;
              const newBlob = await this.audioService.convertWebMToMp3(audioBlob);
              this.audioFile = new File([newBlob], filename, { type: 'audio/mpeg' });
              await this.uploadAudioToFirebase(filename, idAttendance);
            } else if (this.attendance.channel.type === ChannelTypeEnum.CLOUD_API) {
              const filename: string = `${idAttendance}_audio_${dateMilisecond.toString()}.mp3`;
              const newBlob = await this.audioService.convertWebMToMp3(audioBlob);
              this.audioFile = new File([newBlob], filename, { type: 'audio/mpeg' });
              await this.uploadAudioToFirebase(filename, idAttendance);
            }
          } else {
            this.audioChunks = [];
          }
        };

        this.recorder.start();
      }).catch((err) => this.alertService.error(err));
  }

  // Upload audio to firebase
  private async uploadAudioToFirebase(filename: string, idAttendance: string): Promise<void> {
    if (!this.audioFile) {
      this.alertService.error(this.t('attendance.chat.audioUploadError'));
      return;
    }

    try {
      this.isLoading = true;
      const snapshot = await this.firebaseService.uploadFile(this.audioFile, filename, UploadTypeEnum.MESSAGE);
      this.audioUrl = snapshot.url;
      this.isLoading = false;
    } catch (e) {
      this.alertService.error(this.t('attendance.chat.fileUploadError'));
      this.isLoading = false;
    }
  }

  // Stop recording audio
  stopRecording(): void {
    if (this.isRecording) {
      clearInterval(this.intervalId);
      this.recorder.stop();
      this.isRecording = false;
      this.stream?.getTracks().forEach(track => track.stop());
    }
  }

  // Cancel recording audio
  cancelRecording(): void {
    if (this.recorder && this.isRecording) {
      this.isCancel = true;
      this.recorder.stop();
      this.isRecording = false;
      this.stream?.getTracks().forEach(track => track.stop());
    }
  }

  // Toggle recording audio
  toggleRecording(idAttendance: string): void {
    if (this.isRecording) {
      this.isLoading = true;
      this.stopRecording();
    } else {
      this.isLoading = false;
      this.isPreview = true;
      this.startRecording(idAttendance);
    }
  }

  // Cancel preview audio
  cancelPreview(idAttendance: string): void {
    this.isLoading = false;
    this.audioUrl = null;
    this.audioFile = undefined;

    if (this.audioContainer) this.audioContainer.nativeElement.innerHTML = '';
  }

  // Send audio
  sendAudio(attendance: Attendance): void {
    const maxSize = 16 * 1024 * 1024;

    if (this.audioFile && this.audioFile.size > maxSize) {
      this.alertService.error(this.t('attendance.chat.audioTooLarge'));
      return;
    }

    this.isLoading = false;
    this.replyMedia(attendance, MessageTypeEnum.audio, this.audioUrl, this.audioFile.type, this.audioFile.name + '_' + new Date().getTime().toString());
    this.audioUrl = null;

    if (this.audioContainer) this.audioContainer.nativeElement.innerHTML = '';
  }

  getFormattedTime(): string {
    const minutes: string = Math.floor(this.recordingTime / 60).toString().padStart(2, '0');
    const seconds: string = (this.recordingTime % 60).toString().padStart(2, '0');
    return `${minutes}:${seconds}`;
  }

  private refreshStoreAttendancePage() {
    if (!environment.socketActived) {
      this.store.dispatch(getMessages({ page: this.pagerMessage.page, perPage: this.pagerMessage.perPage, idAttendance: this.attendance._id, idCompany: super.getIDCurrentCompany() }));
    }
  }

  private setupForm() {
    this.formGroup = this.formBuilder.group({
      message: [null, Validators.required],
    });
  }

  sendText() {
    if (!this.formGroup.valid) {
      this.formGroup.markAllAsTouched();
      return;
    }

    const text = this.formGroup.get('message').value;
    // An edit keeps its text in the composer until it is answered, so a failed edit
    // loses nothing.
    if (this.isMessageEdit) {
      if (text.trim()) this.replyEditMessage(this.messageEdit, text);
      return;
    }

    // The composer is cleared before the send is answered, so the send is told the text
    // came from it: that is what lets a send refused for balance give the text back.
    this.replyText(this.attendance, text, true);
    this.formGroup.reset('');
  }

  sendMedia(mediaType: 'image' | 'file' | 'location' | 'audio' | 'video' | 'document') {
    switch (mediaType) {
      case 'image': this.inputImagefile.nativeElement.click(); break;
      case 'video': this.inputVideofile.nativeElement.click(); break;
      case 'document': this.inputDocfile.nativeElement.click(); break;
      case 'audio': this.inputAudiofile.nativeElement.click(); break;
    }
  }

  selectTemplate() {
    const dialogRef = this.dialog.open(ChatSelectTemplateComponent, {
      width: '90vw',
      height: '95vh',
      data: this.attendance,
    });

    dialogRef.afterClosed().subscribe((metadataMessage: MetadataMessage) => {
      if (metadataMessage) {
        const content = metadataMessage?.headerParams?.[0] ?? metadataMessage.previewText
        this.replyTextTemplate(this.attendance, content, metadataMessage);
      }
    });
  }

  onSelectMedia(type: string, fileOrEvent: File | any): void {

    const file: File = fileOrEvent instanceof File ? fileOrEvent : (fileOrEvent.target as HTMLInputElement)?.files?.[0];
    const fileTypeLimit = UtilHelper.getFileTypeLimit(file.type);

    if (fileTypeLimit && file.size > fileTypeLimit.maxSize) { // Check type and max size of file
      this.openModalAlert(fileTypeLimit.alertTitle, fileTypeLimit.alertMessage, this.getInputElement(file.type));
      return;
    }

    if (file) {
      const dialogRefUpload = this.modalUploadPreview.open(PreviewMediaComponent, {
        width: '600px',
        data: { type: type, url: '', filename: file.name, isTableResponseApp: false },
      });

      const reader = new FileReader();
      reader.onload = async (fileEvent) => {
        try {
          this.loading = true;

          const dateMilisecond = new Date().getTime();
          const filename: string = file.name + '_' + dateMilisecond.toString();

          this.firebaseService.uploadFile(file, filename, UploadTypeEnum.MESSAGE).then((snapshot: { url: string }) => {
            dialogRefUpload.componentInstance.showPreview(snapshot.url);
            this.loading = false;

            dialogRefUpload.afterClosed().subscribe((result) => {
              if (result) {
                result.message ? this.replyMedia(this.attendance, <MessageTypeEnum>type, result.midia, file.type, result.message, file.name) : this.replyMedia(this.attendance, <MessageTypeEnum>type, result.midia, file.type, undefined, file.name);
              }
              this.resetInputFiles();
            });
          });
        } catch (e) {
          console.error(e);
        }
      };
      reader.readAsArrayBuffer(file);
    } else {
      this.alertService.error(this.t('attendance.chat.fileUploadError'));
      return;
    }
  }

  initCall(attendance: Attendance) {
    this.zapiCallManager.makeOutboundCall(attendance.channel._id, attendance.contact.phone);
  }

  isChannelZAPI(channalType: ChannelTypeEnum): boolean {
    return channalType === ChannelTypeEnum.Z_API
  }

  isChannelRCSAPI(channalType: ChannelTypeEnum): boolean {
    return channalType === ChannelTypeEnum.RCS_API
  }

  // RCS only supports PDF documents; the other channels keep the full office/text list
  public get documentAccept(): string {
    if (this.attendance?.channel?.type === ChannelTypeEnum.RCS_API) {
      return 'application/pdf';
    }
    return '.txt, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/pdf';
  }

  replyTextTemplate(attendance: Attendance, content: string, metadataMessage: MetadataMessage): void {
    const message = MessageHelper.createMessageFromAttendance(attendance, MessageTypeEnum.template, content, null, super.getIDCurrentUser());
    message.metadata = metadataMessage;
    this.createPostMessage(message);
  }

  /**
   * `fromComposer` marks the text sendText() took out of the composer — the only text
   * that has somewhere to go back to when the wallet refuses the send. Quick replies
   * leave the composer as it is, so nothing is given back for them.
   */
  replyText(attendance: Attendance, text: string, fromComposer = false): void {
    const composedText = fromComposer ? text : undefined;
    this.isMessageReplyed ? this.createPostMessage(MessageHelper.createMessageFromAttendance(attendance, MessageTypeEnum.text, text, null, super.getIDCurrentUser(), null, null, this.isMessageReplyed, this.messageReplyed), composedText) :
      this.createPostMessage(MessageHelper.createMessageFromAttendance(attendance, MessageTypeEnum.text, text, null, super.getIDCurrentUser()), composedText);
  }

  replyMedia(attendance: Attendance, type: MessageTypeEnum, content: string, contentType: string, caption?: string, filename?: string): void {
    if (this.attendance._id !== attendance._id) {
      this.alertService.warning(this.t('attendance.chat.audioCancelledOnAttendanceSwitch'));
      sessionStorage.removeItem(`preview_audio_${attendance._id}`);
      if (this.audioContainer) this.audioContainer.nativeElement.innerHTML = '';
      return;
    }

    // RCS media carries no caption — discard it so the agent never sees a caption the customer didn't receive
    if (attendance?.channel?.type === ChannelTypeEnum.RCS_API) {
      caption = undefined;
    }

    const message = caption && (type === 'image' || type === 'document' || type === 'video')
      ? MessageHelper.createMessageFromAttendance(attendance, type, content, contentType, super.getIDCurrentUser(), caption, null, this.isMessageReplyed ? this.isMessageReplyed : false, !!this.messageReplyed ? this.messageReplyed : null)
      : MessageHelper.createMessageFromAttendance(attendance, type, content, contentType, super.getIDCurrentUser(), null, null, this.isMessageReplyed ? this.isMessageReplyed : false, !!this.messageReplyed ? this.messageReplyed : null);

    // Carries the original filename so documents arrive named at the customer (Cloud API / Z-API need it).
    if (filename && type === MessageTypeEnum.document) {
      message.filename = filename;
    }

    this.createPostMessage(message);
  }

  replyContact(attendance: Attendance, type: MessageTypeEnum.contacts, vcardContact: Array<Contact>): void {
    this.createPostMessage(MessageHelper.createMessageFromAttendance(attendance, type, `Envio de mensagem com contato`, null, super.getIDCurrentUser(), null, vcardContact));
  }

  replyLocation(attendance: Attendance, type: MessageTypeEnum.location, place: GooglePlaceType): void {
    this.createPostMessage(MessageHelper.createMessageFromAttendance(attendance, type, `${place.formattedAddress ?? 'Envio de mensagem de localização'}`, null, super.getIDCurrentUser(), null, null, null, null, place));
  }

  replyButton(attendance: Attendance, type: MessageTypeEnum.button, buttonTitle: string, buttonFooter: string, buttonActions: ButtonMessageActionItem[], buttonMessage: string): void {
    this.createPostMessage(
      MessageHelper.createMessageFromAttendance(attendance, type, '', null, super.getIDCurrentUser(), null, null, null, null, null, buttonTitle, buttonFooter, buttonActions, buttonMessage)
    );
  }

  replyEditMessage(message: Message, text: string): void {
    const { signature } = splitAgentSignature(message.content, this.attendance?.channel?.type, message.user?.name);
    const newContent = signature ? `${signature}\n${text}` : text;

    this.messageService.editMessage(message._id, newContent)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.alertService.success(this.t('attendance.chat.messageEditedSuccess'));
          // Closes this edit only: a cancel, a repeated save or another edit started
          // while it was in flight keeps the composer as it is now.
          if (this.messageEdit?._id === message._id) this.leaveMessageEdit();
          // Page 1 holds the edited message: an edit is allowed within 15 minutes of the send.
          this.store.dispatch(getMessages({ page: 1, perPage: this.pagerMessage.perPage, idAttendance: this.attendance._id, idCompany: super.getIDCurrentCompany() }));
        },
        // The edit stays open with its text; the HTTP error interceptor shows the reason.
        error: () => { },
      });
  }

  exportConversation(): void {
    this.isLoadingExport = true;
    this.messageService.getByAttendance(this.attendance._id).subscribe({
      next: (messages: Message[]) => {
        this.exportService.exportConversationToPdf(this.attendance, messages)
        this.isLoadingExport = false
      }
    });
  }

  // `composedText` is the text the composer was cleared of for this send, as the agent
  // typed it — `message.content` may already carry the signature.
  private createPostMessage(message: Message, composedText?: string) {
    // RCS has no rich text, so the WhatsApp markers would reach the customer verbatim.
    const signature = buildAgentSignature(this.attendance?.channel?.type, this.getNameCurrentUser());
    if (message.type === MessageTypeEnum.text && super.getSignatureConversation() && !!signature) {
      message.content = `${signature}\n${message.content}`;
    }

    let assignUserSubscription = of({});
    const shouldAssignUser = !this.attendance.user || this.attendance.status !== AttendanceStatusEnum.IN_PROGRESS;
    if (shouldAssignUser) {
      assignUserSubscription = this.attendanceService.assignUser(this.attendance._id, super.getIDCurrentUser());
    }
    assignUserSubscription.pipe(
      takeUntil(this.destroy$),
      catchError((error) => {
        return throwError(() => error);
      })
    ).subscribe({
      next: (assignUserResult) => {
        forkJoin({
          messageServiceCreateSubscription: this.messageService.create(message)
        })
          .pipe(
            takeUntil(this.destroy$),
            // A side effect only: the failure goes on to wherever it went before.
            tap({
              error: (error) => {
                this.restoreComposedTextOnRefusal(error, composedText);
                this.offerTemplateOnHybridWindowClosed(error);
              },
            }),
          )
          .subscribe(({ messageServiceCreateSubscription }) => {
            if (shouldAssignUser) {
              this.attendance = <Attendance>assignUserResult;
              this.store.dispatch(setAttendance({ attendance: this.attendance }));
              this.alertService.success(this.t('attendance.chat.userTookOverAttendance', { name: super.getNameCurrentUser() }));
            } else if (!this.messages.some((item: Message) => item._id === messageServiceCreateSubscription._id)) {
              // The socket event of this very send can land before its HTTP answer — appending
              // without the check shows the agent's own message twice until the list is refetched
              // (DEV-2070). The socket subscription makes the same check against this list.
              this.messages = [...this.messages, messageServiceCreateSubscription];
              this.countMessageForCopilot();
            }
            this.tabService.selectedTabIndex(2);
            this.isMessageReplyed = false;
          });
      },
      error: (error) => {
        console.error('Erro ao atribuir usuário:', error);
      }
    });
  }

  /**
   * Gives the agent's text back when the wallet refuses the send for lack of balance
   * (HTTP 402) — SPEC-2026-10-whatsapp-wallet-credit-line-channels AC-30.
   *
   * sendText() clears the composer before the send is answered. The reason of the
   * refusal is shown by the HTTP error interceptor, but without the text the agent
   * could only act on it by typing the message again. Every other failure keeps the
   * outcome it had.
   *
   * The composer is filled only while it is still free for that text: never over
   * something typed while the send was in flight, and never once the agent started
   * editing a message, where the same field holds that message's new content. A
   * refusal answered after an attendance switch never gets here — the switch fires
   * destroy$, which drops the pending send — so the text cannot land in another
   * conversation's composer.
   */
  private restoreComposedTextOnRefusal(error: HttpErrorResponse, composedText?: string): void {
    const refusedForBalance = error?.status === HttpStatusCode.PaymentRequired;
    if (!refusedForBalance || !composedText || this.isMessageEdit) return;

    const control = this.formGroup?.get('message');
    if (!control || (control.value ?? '').toString().trim()) return;

    control.setValue(composedText);
  }

  /**
   * A Hybrid channel refused a free-form send because the 24h window is closed (HTTP 409,
   * `errors.message.hybridWindowClosed` — SPEC-2026-10-whatsapp-hybrid-channel RF-11, AC-09):
   * only an official template reaches the customer now, so the template picker opens right away.
   * The HTTP error interceptor does not toast a 409, so the reason the API gave is shown here.
   */
  private offerTemplateOnHybridWindowClosed(error: HttpErrorResponse): void {
    if (error?.status !== HttpStatusCode.Conflict || error?.error?.key !== HYBRID_WINDOW_CLOSED_ERROR_KEY) return;
    this.alertService.error(error.error?.message ?? this.t('attendance.chat.hybridWindowClosed'));
    this.selectTemplate();
  }

  /**
   * The attendance runs on a Hybrid channel whose session side is paired but down: free-form
   * messages keep going out through the official side until it comes back (RF-09, RF-22).
   */
  isHybridSessionDisconnected(): boolean {
    const channel = this.attendance?.channel;
    return channel?.type === ChannelTypeEnum.CLOUD_API
      && channel?.hybrid === true
      && !!channel?.hybridConfig?.sessionChannel
      && channel?.hybridConfig?.sessionConnected !== true;
  }

  toggleSidebar() {
    this.sidebarRight = !this.sidebarRight;
    this.store.dispatch(getAttendance({ idAttendance: this.attendance._id }))
    this.store.dispatch(openCloseSidebarRight({ sidebarRight: this.sidebarRight }));
    this.store.dispatch(getNotes({ idAttendance: this.attendance._id, idContact: this.attendance.contact._id }));

    this.collapseEmitted.emit(this.sidebarRight)
  }

  focusInput(): void {
    this.isInputFocused = true;
  }

  blurInput(): void {
    this.isInputFocused = false;
  }

  enterEventPress(event: any, ta: HTMLTextAreaElement): void {
    event.preventDefault();
    event.stopPropagation();
    this.sendText();
    this.autoResizeTextArea(ta, 3);
  }

  toggleContainerEmoji(): void {
    clearTimeout(this.clearTimeout)

    this.showContainerEmoji = !this.showContainerEmoji;

    this.clearTimeout = setTimeout(() => {
      this.addClickOutsideListener();
    })
  }

  addClickOutsideListener() {
    this.clickOutsideListener = this.renderer.listen('document', 'click', (event: MouseEvent) => {
      if (this.showContainerEmoji && this.emojiContainer) {
        const modalElement = this.emojiContainer.nativeElement as HTMLElement;
        const clickedInside = modalElement?.contains(event.target as Node);
        if (!clickedInside) {
          this.closedContainerEmoji();
        }
      }
    });
  }

  addEmoji(event: any): void {
    const messageFg = this.formGroup.get('message');
    const currentText = messageFg.value || '';

    messageFg.setValue(currentText + event.emoji.native);
  }

  closedContainerEmoji(): void {
    this.showContainerEmoji = false;
    this.clickOutsideListener()
    this.clickOutsideListener = null
  }

  openAssignedUserTransferModal() {
    const dialogRef = this.dialog.open(AssignedUserComponent, {
      width: '600px',
      data: this.attendance
    });
    dialogRef.afterClosed().subscribe((attendance: Attendance) => {
      if (!!attendance) {
        this.store.dispatch(setAttendance({ attendance }));
        this.tabService.selectedTabIndex(1);
      }
    });
  }

  private closeAttendanceFunc(closeForced: boolean, tabulation: TabulationStatus): void {
    this.attendanceService.closeAttendance(this.attendance._id, closeForced, tabulation)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (attendance: Attendance) => {
          this.store.dispatch(setAttendance({ attendance }));
          this.alertService.success(this.t('attendance.chat.attendanceClosedSuccess'));
          this.store.dispatch(getAttendances({
            page: this.pagerParamsState.page,
            perPage: this.pagerParamsState.perPage,
            search: this.pagerParamsState.search,
            params: this.pagerParamsState.params,
          }));
        }
      })
  };

  confirmationCloseAttendance() {
    this.listTabulations$
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (tabulations: Array<Tabulation>) => {
          const tabsByChannel = tabulations.filter(tab => tab?.channel?._id === this.attendance.channel._id);
          const dialogRef = this.dialog.open(ConfirmationCloseAttendanceComponent, {
            data: tabsByChannel,
            width: '600px',
          });

          dialogRef.afterClosed().subscribe(result => {
            if (result) {
              const { tabulations, description, closeForced } = result;

              let tabulationStatus: TabulationStatus | undefined;

              if (!closeForced) {
                if (tabulations?.length > 0) {
                  tabulationStatus = { tabulations, description };
                }
              }

              this.closeAttendanceFunc(closeForced, tabulationStatus);
            }
          })
        },
        error: (err) => this.alertService.error(err.error.message)
      });
  }

  openModalResponse(): void {
    const refBottom = this.modalResponse.open(ModalResponseFastComponent, {
      width: '70rem',
      data: <ModalResponseFastData>{
        channeltype: this.attendance.channel
      }
    });

    refBottom.afterClosed().subscribe(async (result) => {
      if (result !== null && result !== undefined) {
        if (result.vcardContact) {
          this.replyContact(this.attendance, MessageTypeEnum.contacts, result.vcardContact);
        } else if (result.place) {
          this.replyLocation(this.attendance, MessageTypeEnum.location, result.place);
        } else {
          const messageFg = this.formGroup.get('message');
          const newContent = UtilHelper.replaceIdentifiers(
            result.message,
            this.attendance,
            super.getNameCompanyCurrentUser(),
            super.getNameCurrentUser()
          );

          if (result.midia || result.midia === 'N/A') {
            const mediaType = this.helperExtension(result.midia);
            const isCaptionSend = mediaType === 'image' || mediaType === 'video' || mediaType === 'document';

            if (isCaptionSend) {
              this.replyMedia(this.attendance, mediaType, result.midia, result.response.contentType, newContent);
            } else {
              this.replyMedia(this.attendance, mediaType, result.midia, result.response.contentType);
              setTimeout(() => {
                this.replyText(this.attendance, newContent);
              }, 700);
            }
          } else if (result?.buttonActions?.length > 0) {
            if (this.attendance.channel.type === ChannelTypeEnum.RCS_API) {
              this.alertService.error(this.t('attendance.chat.rcsButtonsNotSupported'));
              return;
            }

            if (this.attendance.channel.type === ChannelTypeEnum.CLOUD_API) {
              const hasInvalidButtons = result.buttonActions.some(btn =>
                btn.type && btn.type.toLowerCase() !== 'reply'
              );

              if (hasInvalidButtons) {
                this.alertService.error(this.t('attendance.chat.whatsappOfficialOnlyReplyButtons'));
                return;
              }
            }

            const newContent = UtilHelper.replaceIdentifiers(result.message, this.attendance, super.getNameCompanyCurrentUser(), super.getNameCurrentUser());
            this.replyButton(this.attendance, MessageTypeEnum.button, result?.title, result?.footer, result.buttonActions, newContent);
          } else {
            messageFg.setValue(newContent);
          }
        }
      }
    });
  }


  get cloudWindowExpired(): boolean {
    return conversationWindowOf(this.attendance) === 'expired';
  }

  /**
   * Whether the agent may compose a message on the current attendance.
   *
   * Renamed from `isExpiredisConversation()`, which stated the opposite of what it returns:
   * `true` has always meant "composing is allowed".
   *
   * - **Cloud API** — unchanged: composing is allowed only while the customer-service
   *   conversation is open and its window has not elapsed.
   * - **RCS** — refused outright on a campaign-only account, which has no conversational
   *   route at all; otherwise follows the 24-hour service session (SPEC-2026-08 RF-15):
   *   allowed while the attendance never had a session (`NONE`, an agent-started
   *   conversation) or its session is still running (`OPEN`); refused once it has elapsed
   *   (`EXPIRED`). Both mirror refusals the backend applies on the send path.
   * - **Every other channel** — unrestricted, as before.
   */
  canComposeMessage(): boolean {
    const channelType = this.attendance?.channel?.type;

    if (channelType === ChannelTypeEnum.CLOUD_API) {
      const isConversation = this.attendance?.inConversation;
      if (isConversation) {
        const expiredAtDate = new Date(this.attendance.expiredAt);
        const currentDate = new Date();
        const isExpired = expiredAtDate < currentDate;
        return isExpired ? !isConversation : isConversation;
      }
      return false;
    }

    if (channelType === ChannelTypeEnum.RCS_API) {
      if (this.isRCSChannelNotConversational()) {
        return false;
      }
      return ConversationWindowUtil.stateOf(channelType, this.attendance) !== ConversationWindowStateEnum.EXPIRED;
    }

    return true;
  }

  /**
   * The attendance runs on an RCS channel whose provider account is campaign-only.
   *
   * Distinct from an elapsed session and shown with its own message: a session can be
   * reopened by the customer, while this state is a channel configuration an
   * administrator has to change — telling the agent to close and reopen the
   * conversation would send them round a loop that cannot end.
   */
  isRCSChannelNotConversational(): boolean {
    const channel = this.attendance?.channel;
    return channel?.type === ChannelTypeEnum.RCS_API && !isRCSConversational(channel);
  }

  private helperExtension(midia: string): MessageTypeEnum {
    const decodedUrl = decodeURIComponent(midia);

    const fileNameWithQuery = decodedUrl.split('/').pop() || '';
    const fileName = fileNameWithQuery.split('?')[0];

    const extension = fileName.split('.').pop()?.toLowerCase();

    const regex = /_(\d+)/;
    const nameWithoutPart = extension.replace(regex, '');

    switch (nameWithoutPart) {
      case 'mp4':
        return MessageTypeEnum.video;
      case 'pdf':
        return MessageTypeEnum.document;
      case 'mp3':
        return MessageTypeEnum.audio;
      default:
        return MessageTypeEnum.image;
    }
  }

  formatDuration(duration: number): string {
    const minutes = Math.floor(duration / 60);
    const seconds = Math.floor(duration % 60);
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  }

  togglePause(): void {
    if (this.attendance.status === AttendanceStatusEnum.PAUSED) {
      this.continueAttendance();
    } else {
      this.pauseAttendance();
    }
  }

  pauseAttendance(): void {
    this.attendanceService.pauseAttendance(this.attendance._id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (attendance: Attendance) => {
          this.attendance = attendance;
          this.alertService.success(this.t('attendance.chat.attendancePausedSuccess'));
          this.tabService.selectedTabIndex(3);
        },
        complete: () => {
          this.refreshStoreAttendancePage();
        },
      });
  }

  continueAttendance(): void {
    this.attendanceService.continueAttendance(this.attendance._id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (attendance: Attendance) => {
          this.attendance = attendance;
          this.alertService.success(this.t('attendance.chat.attendanceResumedSuccess'));
          this.tabService.selectedTabIndex(2);
        },
        complete: () => {
          this.refreshStoreAttendancePage();
        },
      });
  }

  /**
   * "Continue conversation" on an RCS attendance whose 24h service session elapsed
   * (SPEC-2026-08 ADR-003). The backend returns the attendance to the NONE window state;
   * `canComposeMessage()` unlocks the composer on its own once the updated attendance lands,
   * and the next sends are charged as single messages until the customer replies — which is
   * what the confirmation says before anything is sent.
   */
  continueRcsSession(): void {
    const dialogRef = this.dialog.open(ConfirmationComponent, {
      data: this.t('attendance.chat.rcsContinueSessionConfirm'),
      width: '500px',
    });
    dialogRef.afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((confirmed) => {
        if (Boolean(confirmed) !== true) return;
        this.attendanceService.continueRcsSession(this.attendance._id)
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: (attendance: Attendance) => {
              this.attendance = attendance;
              this.alertService.success(this.t('attendance.chat.rcsContinueSessionSuccess'));
            },
            complete: () => {
              this.refreshStoreAttendancePage();
            },
          });
      });
  }

  private resetInputFiles(): void {
    this.inputImagefile.nativeElement.value = '';
    this.inputVideofile.nativeElement.value = '';
    this.inputAudiofile.nativeElement.value = '';
    this.inputDocfile.nativeElement.value = '';
  }

  private openModalAlert(title: string, message: string, inputElementFile: ElementRef<HTMLInputElement>): void {
    const dialogRefAlert = this.modalAlert.open(AlertModalComponent, {
      width: '600px',
      maxHeight: '300px',
      data: { title: title, message: message },
    });
    dialogRefAlert.afterClosed().subscribe(() => inputElementFile.nativeElement.value = '');
  }

  private getInputElement(fileType: string): ElementRef {
    if (fileType.startsWith('image/')) {
      return this.inputImagefile;
    } else if (fileType.startsWith('video/')) {
      return this.inputVideofile;
    } else if (fileType.startsWith('audio/')) {
      return this.inputAudiofile;
    } else {
      return this.inputDocfile;
    }
  }

  openModalScheduled(attendance: Attendance): void {
    this.modalScheduleMessage.open(ChatMessageScheduleComponent, {
      width: '950px',
      data: { attendance: attendance }
    });
  }

  openModalScheduledTemplate(attendance: Attendance): void {
    this.modalScheduleMessage.open(ChatTemplateScheduleComponent, {
      width: '950px',
      data: { attendance: attendance }
    });
  }

  openModalScheduledList(attendance: Attendance): void {
    this.modalScheduleMessageList.open(ChatMessageScheduleListComponent, {
      width: '700px',
      maxHeight: '700px',
      data: attendance
    });
  }

  showDetailsAttendanceHitory(item: Attendance) {
    this.dialog.open(AttendanceHistoryComponent, {
      width: '90vw',
      height: '95vh',
      data: <AttendanceHistoryData>{
        idContact: item.contact._id,
        idAttendance: item._id,
      }
    });
  }

  showTimelineAttendance(item: Attendance) {
    this.dialog.open(TimelineAttendanceComponent, {
      width: '800px',
      height: '600px',
      data: { idAttendance: item._id }
    });
  }

  sendContact(): void {
    const dialogRef = this.modalSendContact.open(ContactListModalComponent, {
      maxHeight: '1200px',
      minHeight: '900px',
      width: '1200px'
    });
    dialogRef.afterClosed().subscribe((contact: Contact) => {
      if (!!contact) {
        this.replyContact(this.attendance, MessageTypeEnum.contacts, [contact]);
      }
    });
  }

  getMessageReply(event: Message): void {
    if (this.isMessageEdit) this.leaveMessageEdit();
    this.isMessageReplyed = true;
    this.messageReplyed = event;
  };

  cancelReply(): void {
    this.isMessageReplyed = false;
  }

  sendLocation(): void {
    const dialogRef = this.modalSendLocation.open(GoogleMapsComponent, {
      width: '900px',
      height: '750px',
    });
    dialogRef.afterClosed().subscribe((place: GooglePlaceType) => {
      if (!!place) {
        this.replyLocation(this.attendance, MessageTypeEnum.location, place);
      }
    });
  }

  getMessageEdit(event: Message): void {
    const idUser: unknown = event?.user?._id;
    const createdTime = new Date(event.createdAt).getTime();
    const time = new Date().getTime() - createdTime;
    if (time > 15 * 60 * 1000) {
      this.alertService.info(this.t('attendance.chat.cannotEditMessageAfter15Minutes'));
      return;
    }

    if (super.isAttendant() && idUser !== super.getCurrentUserUser()._id) {
      this.alertService.warning(this.t('attendance.chat.cannotEditMessageNotYours'));
      return;
    }

    const composer = this.formGroup.get('message');
    if (!this.isMessageEdit) this.draftBeforeEdit = composer.value;
    this.isMessageEdit = true;
    this.isMessageReplyed = false;
    this.messageEdit = event;
    // The composer holds the text only; the save puts the original signature back.
    composer.setValue(splitAgentSignature(event.content, this.attendance?.channel?.type, event.user?.name).text);
    setTimeout(() => this.focusComposerAtEnd());
  }

  cancelEdit(): void {
    this.leaveMessageEdit();
  }

  private leaveMessageEdit(): void {
    this.isMessageEdit = false;
    this.messageEdit = null;
    this.formGroup.get('message').setValue(this.draftBeforeEdit ?? '');
    this.draftBeforeEdit = null;
  }

  private focusComposerAtEnd(): void {
    const textArea = this.messageTextArea?.nativeElement;
    if (!textArea) return;
    textArea.focus();
    textArea.setSelectionRange(textArea.value.length, textArea.value.length);
  }


  loadPage(): boolean {
    if (this.pagerMessage.list.length < this.pagerMessage.total) {
      this.store.dispatch(getMessages({
        page: this.pagerMessage.page + 1,
        perPage: this.pagerMessage.perPage,
        idAttendance: this.attendance._id, idCompany: super.getIDCurrentCompany()
      }));
      return true;
    }
    return false;
  }

  // Inbox search hit: the message belongs to the attendance already open, so it goes straight
  // to the scroll engine and never through the reply / deep-link resolution below.
  private resolvePendingFocus(): void {
    const focus = this.pendingFocus;
    if (!focus || focus.attendanceId !== this.attendance?._id || this.messages.length === 0) {
      return;
    }
    this.pendingFocus = null;
    // Let the page render before looking the element up, or older history is fetched for nothing.
    setTimeout(() => {
      this.armPendingScroll(focus.messageId, this.pagerMessage.list.length);
      this.resolvePendingScroll();
    }, 150);
  }

  scrollToReplyMessage(reply: Message): void {
    const idMessage = reply?._id;
    if (!idMessage) {
      return;
    }

    const idReplyAttendance = this.resolveIdAttendance(reply.attendance);
    if (idReplyAttendance && this.attendance?._id && idReplyAttendance !== this.attendance._id) {
      this.openAttendanceAtMessage(idReplyAttendance, idMessage);
      return;
    }

    this.armPendingScroll(idMessage, this.pagerMessage.list.length);
    this.resolvePendingScroll();
  }

  private resolveIdAttendance(attendance: Attendance | string | null | undefined): string | null {
    if (!attendance) {
      return null;
    }
    return typeof attendance === 'string' ? attendance : (attendance._id ?? null);
  }

  private openAttendanceAtMessage(idAttendance: string, idMessage: string): void {
    this.alertService.info(this.t('attendance.chat.openingRepliedMessageAttendance'));
    this.attendanceService.getById(idAttendance)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (attendance: Attendance) => {
          if (!attendance?._id) {
            this.alertService.warning(this.t('attendance.chat.repliedMessageAttendanceUnavailable'));
            return;
          }
          this.router.navigate(['/attendance/panel'], {
            queryParams: { id: attendance._id, status: attendance.status, message: idMessage },
          });
        },
        error: () => this.alertService.warning(this.t('attendance.chat.repliedMessageAttendanceUnavailable')),
      });
  }

  private listenDeepLinkMessage(): void {
    this.route.queryParams
      .pipe(takeUntil(this.routeDestroy$))
      .subscribe((params) => {
        const idAttendance = params['id'];
        const idMessage = params['message'];
        this.deepLinkScrollRequest = (idAttendance && idMessage) ? { idAttendance, idMessage } : null;
      });
  }

  private armDeepLinkScroll(idAttendance: string): void {
    const request = this.deepLinkScrollRequest;
    if (!request || request.idAttendance !== idAttendance) {
      return;
    }
    this.deepLinkScrollRequest = null;
    this.armPendingScroll(request.idMessage, 0);
  }

  private armPendingScroll(idMessage: string, loadedCount: number): void {
    this.pendingScrollMessageId = idMessage;
    this.scrollLoadAttempts = 0;
    this.scrollLoadHighWater = loadedCount;
    this.scrollInfoShown = false;
  }

  private resolvePendingScroll(): void {
    const messageId = this.pendingScrollMessageId;
    if (!messageId) {
      return;
    }

    const element = document.getElementById(messageId);
    if (element) {
      this.pendingScrollMessageId = null;
      this.scrollToAndHighlight(element);
      return;
    }

    if (this.pagerMessage.total == null) {
      return;
    }

    const hasMorePages = this.pagerMessage.list.length < this.pagerMessage.total;
    if (hasMorePages) {
      if (this.pagerMessage.list.length > this.scrollLoadHighWater) {
        this.scrollLoadHighWater = this.pagerMessage.list.length;
        this.scrollLoadAttempts = 0;
      }

      if (this.scrollLoadAttempts < this.maxScrollLoadAttempts) {
        if (!this.scrollInfoShown) {
          this.scrollInfoShown = true;
          this.alertService.info(this.t('attendance.chat.loadingMoreHistoryMessages'));
        }
        this.scrollLoadAttempts++;
        if (!this.loadPage()) {
          this.pendingScrollMessageId = null;
          this.alertService.warning(this.t('attendance.chat.repliedMessageNotAvailable'));
        }
        return;
      }
      this.pendingScrollMessageId = null;
      this.alertService.warning(this.t('attendance.chat.repliedMessageNotFoundInHistory'));
      return;
    }
    this.pendingScrollMessageId = null;
    this.alertService.warning(this.t('attendance.chat.repliedMessageNotAvailable'));
  }

  private scrollToAndHighlight(element: HTMLElement): void {
    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    this.highlightJumpedMessage(element);

    const img = element.querySelector('img');
    if (img && !img.complete) {
      img.addEventListener(
        'load',
        () => element.scrollIntoView({ behavior: 'smooth', block: 'center' }),
        { once: true },
      );
    }
  }

  private highlightJumpedMessage(element: HTMLElement): void {
    this.clearJumpHighlight();
    this.highlightedElement = element;
    this.renderer.addClass(element, 'message-jump-highlight');
    setTimeout(() => this.clearJumpHighlight(), 2500);
  }

  private clearJumpHighlight(): void {
    if (this.highlightedElement) {
      this.renderer.removeClass(this.highlightedElement, 'message-jump-highlight');
      this.highlightedElement = null;
    }
  }

  blockOrUnblock(contact: Contact, channel: Channel): void {
    const dialogRef = this.dialog.open(ConfirmationComponent, {
      data: contact?.blockedChannels?.includes(channel._id) ? this.t('attendance.chat.confirmUnblockContact') : this.t('attendance.chat.confirmBlockContact'),
      width: '500px',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (Boolean(result) === true) {
        if (!!contact.blockedChannels) {
          const contactIsBlockedInChannel = contact?.blockedChannels?.includes(channel._id);

          if (contactIsBlockedInChannel) {
            this.contactService.unblockContact(contact, channel)
              .pipe(takeUntil(this.destroy$))
              .subscribe({
                next: () => {
                  this.alertService.success(this.t('attendance.chat.contactUnblockedSuccess'));
                  this.store.dispatch(getAttendance({ idAttendance: this.attendance._id }));
                  this.store.dispatch(getAttendances({
                    page: this.pagerParamsState.page,
                    perPage: this.pagerParamsState.perPage,
                    search: this.pagerParamsState.search,
                    params: this.pagerParamsState.params,
                  }));
                },
                error: (err) => this.alertService.error(err),
              });
          } else {
            this.contactService.blockContact(contact, channel)
              .pipe(takeUntil(this.destroy$))
              .subscribe({
                next: () => {
                  this.alertService.success(this.t('attendance.chat.contactBlockedSuccess'));
                  this.store.dispatch(getAttendance({ idAttendance: this.attendance._id }));
                  this.store.dispatch(getAttendances({
                    page: this.pagerParamsState.page,
                    perPage: this.pagerParamsState.perPage,
                    search: this.pagerParamsState.search,
                    params: this.pagerParamsState.params,
                  }));
                },
                error: (err) => this.alertService.error(err),
              });
          }
        }
      }
    });
  }

  contactIsBlocked(contact: Contact, channel: Channel): boolean {
    return contact?.blockedChannels?.includes(channel._id);
  }

  openDialogCrm(attendance: Attendance): void {
    this.dialog.open(CrmIntegrationsComponent, {
      width: '850px',
      height: '400px',
      data: attendance
    });
  }

  handleKeydown(event: KeyboardEvent): void {
    const messageControl = this.formGroup.get('message');

    if (event.key === 'Escape' && this.isMessageEdit) {
      event.preventDefault();
      this.cancelEdit();
      return;
    }

    if (event.key === '/' && !messageControl?.value) {
      event.preventDefault();
      this.openModalResponseBottom();
    }
  }

  openModalResponseBottom(): void {
    const bottomRef = this.bottomSheet.open(BottomSheetResponseFastComponent, {
      panelClass: 'custom-bottom-sheet',
      data: {
        channeltype: this.attendance.channel.type,
        attendance: this.attendance,
        channel: this.attendance.channel
      }
    });

    bottomRef.afterDismissed().subscribe((result) => {
      if (result !== null && result !== undefined) {
        if (result.vcardContact) {
          this.replyContact(this.attendance, MessageTypeEnum.contacts, result.vcardContact);
        } else if (result.place) {
          this.replyLocation(this.attendance, MessageTypeEnum.location, result.place);
        } else {
          const messageFg = this.formGroup.get('message');

          if (result.midia || result.midia === 'N/A') {
            const mediaType = this.helperExtension(result.midia);
            const isCaptionSend = mediaType === 'image' || mediaType === 'video' || mediaType === 'document';

            if (isCaptionSend) {
              const newContent = UtilHelper.replaceIdentifiers(result.message, this.attendance, super.getNameCompanyCurrentUser(), super.getNameCurrentUser());
              this.replyMedia(this.attendance, mediaType, result.midia, result.response.contentType, newContent);
            } else {
              this.replyMedia(this.attendance, mediaType, result.midia, result.response.contentType);
              setTimeout(() => {
                const newContent = UtilHelper.replaceIdentifiers(result.message, this.attendance, super.getNameCompanyCurrentUser(), super.getNameCurrentUser());
                this.replyText(this.attendance, newContent);
              }, 700);
            }
          } else if (result?.buttonActions?.length > 0) {
            if (this.attendance.channel.type === ChannelTypeEnum.RCS_API) {
              this.alertService.error(this.t('attendance.chat.rcsButtonsNotSupported'));
              return;
            }

            if (this.attendance.channel.type === ChannelTypeEnum.CLOUD_API) {
              const hasInvalidButtons = result.buttonActions.some(btn =>
                btn.type && btn.type.toLowerCase() !== 'reply'
              );

              if (hasInvalidButtons) {
                this.alertService.error(this.t('attendance.chat.whatsappOfficialOnlyReplyButtons'));
                return;
              }
            }

            const newContent = UtilHelper.replaceIdentifiers(result.message, this.attendance, super.getNameCompanyCurrentUser(), super.getNameCurrentUser());
            this.replyButton(this.attendance, MessageTypeEnum.button, result?.title, result?.footer, result.buttonActions, newContent);
          } else {
            const newContent = UtilHelper.replaceIdentifiers(result.message, this.attendance, super.getNameCompanyCurrentUser(), super.getNameCurrentUser());
            messageFg.setValue(newContent);
          }
        }
      };
    });
  }

  openCall(): void {
    const ref = this.modalCallPhone.open(CallPhoneComponent, {
      data: this.attendance.contact,
    });

    ref.afterClosed().subscribe(result => {
    });
  }

  isAIActive(): boolean {
    return this.attendance?.metadata?.integrations?.ai?.actived === true;
  }

  activeUnactiveAI() {
    if (this.isAIActive()) {
      this.attendanceService.activeUnactiveAI(this.attendance._id, false, null, null)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: () => {
            this.store.dispatch(getAttendance({ idAttendance: this.attendance._id }));
            this.alertService.success(this.t('attendance.chat.aiDeactivatedSuccess'));
          },
          error: (err) => this.alertService.error(err.error.message)
        });
      return;
    }

    const dialogRef = this.dialog.open(AiAssistantActivatorSelectorComponent, {
      width: '600px',
      data: this.attendance,
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.attendanceService.activeUnactiveAI(this.attendance._id, result.activeIAModule, result.integration, result.assistant)
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: () => {
              const updatedAi = {
                name: result.assistant?.name || null,
                actived: result.activeIAModule,
                integration: result.integration,
                [result.assistant?.name]: {
                  assistant: result.assistant,
                  conversationId: this.attendance?.metadata?.integrations.ai?.openai?.conversationId,
                  threadId: this.attendance?.metadata?.integrations.ai?.openai?.threadId
                }
              };
              const updatedIntegrations = { ...this.attendance?.metadata?.integrations, ai: updatedAi };
              const updatedMetadata = <MetadataAttedance>{ ...this.attendance?.metadata, integrations: updatedIntegrations };
              this.attendance = { ...this.attendance, metadata: updatedMetadata };
              this.store.dispatch(getAttendance({ idAttendance: this.attendance._id }));
              this.alertService.success(this.t('attendance.chat.aiActivatedSuccess'));
            },
            error: (err) => this.alertService.error(err.error.message)
          });
      }
    });
  }

  toggleSearch(): void {
    this.searchOpen = !this.searchOpen;

    if (!this.searchOpen) {
      this.clearSearchComplete();
    }
  }

  searchMessages(): void {
    this.clearSearch();

    if (!this.searchText || this.searchText.trim() === '') {
      return;
    }

    const iframes = document.querySelectorAll('iframe');
    if (iframes.length > 0) {
    }

    const searchTerm = this.searchText.toLowerCase();
    const searchResults: { index: number, element: HTMLElement }[] = [];

    document.querySelectorAll('.ctext-wrap__content').forEach((el, index) => {
      const text = el.textContent?.toLowerCase() || '';
      if (text.includes(searchTerm)) {
        searchResults.push({
          index,
          element: el as HTMLElement
        });
      }
    });

    if (searchResults.length === 0) {
      document.querySelectorAll('.ctext-wrap__content').forEach((el, index) => {
        const text = el.textContent?.toLowerCase() || '';
        if (text.includes(searchTerm)) {
          searchResults.push({
            index,
            element: el as HTMLElement
          });
        }
      });
    }

    this.searchResults = searchResults;
    this.totalSearchResults = this.searchResults.length;

    if (this.totalSearchResults > 0) {
      this.navigateToSearchResult(0);
    } else {
      this.alertService.warning(this.t('attendance.chat.noSearchResultsFor', { term: this.searchText }));
      console.warn('Nenhum resultado encontrado para a pesquisa:', this.searchText);
    }
  }

  nextSearchResult(): void {
    if (this.searchResults.length === 0) {
      return;
    }

    const nextIndex = (this.currentSearchResultIndex + 1) % this.searchResults.length;
    this.navigateToSearchResult(nextIndex);
  }

  previousSearchResult(): void {
    if (this.searchResults.length === 0) {
      return;
    }

    const prevIndex = this.currentSearchResultIndex <= 0
      ? this.searchResults.length - 1
      : this.currentSearchResultIndex - 1;
    this.navigateToSearchResult(prevIndex);
  }

  searchInMoreMessages(): void {
    if (!this.searchText || !this.searchText.trim()) {
      return;
    }

    this.isLoading = true;
    this.alertService.info(this.t('attendance.chat.loadingMoreHistoryMessages'));

    this.loadPage();

    setTimeout(() => {
      this.searchMessages();
      this.isLoading = false;
    }, 1500);
  }

  navigateToSearchResult(index: number): void {
    if (index < 0 || index >= this.searchResults.length) {
      return;
    }

    if (this.currentSearchResultIndex >= 0 && this.currentSearchResultIndex < this.searchResults.length) {
      this.removeHighlight(this.searchResults[this.currentSearchResultIndex].element);
    }
    this.currentSearchResultIndex = index;
    const currentElement = this.searchResults[index].element;
    this.highlightElement(currentElement);
    currentElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  highlightElement(element: HTMLElement): void {
    this.removeHighlight(element);

    if (!this.searchText || !this.searchText.trim()) {
      return;
    }

    const searchTerm = this.searchText.trim();
    const regex = new RegExp(`(${this.escapeRegExp(searchTerm)})`, 'gi');

    const highlightTextNodes = (node: Node): void => {
      if (node.nodeType === Node.TEXT_NODE) {
        const text = node.textContent || '';
        if (regex.test(text)) {
          const span = document.createElement('span');
          span.innerHTML = text.replace(regex, '<span class="search-highlight search-highlight-wrapper">$1</span>');
          node.parentNode?.replaceChild(span, node);
        }
      } else if (node.nodeType === Node.ELEMENT_NODE && !node.nodeName.match(/^(script|style)$/i)) {
        Array.from(node.childNodes).forEach(child => highlightTextNodes(child));
      }
    };

    highlightTextNodes(element);
  }

  removeHighlight(element: HTMLElement): void {
    element.querySelectorAll('.search-highlight-wrapper').forEach(el => {
      const parent = el.parentNode;
      while (el.firstChild) {
        parent.insertBefore(el.firstChild, el);
      }
      parent.removeChild(el);
    });

    const allHighlighted = element.querySelectorAll('.search-highlight');
    allHighlighted.forEach(el => {
      el.classList.remove('search-highlight');
    });
  }

  escapeRegExp(string: string): string {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  clearSearch(): void {
    this.searchResults.forEach(result => {
      this.removeHighlight(result.element);
    });
    this.searchResults = [];
    this.currentSearchResultIndex = -1;
    this.totalSearchResults = 0;
  }

  clearSearchComplete(): void {
    this.clearSearch();
    this.searchText = '';
  }

  openModalButtons(): void {
    const dialogRef = this.dialog.open(SendButtonsAttendanceComponent, {
      width: '900px',
      maxHeight: '90vh',
      autoFocus: false,
      data: this.attendance,
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result !== null && result !== undefined) {
        if (result.vcardContact) {
          this.replyContact(this.attendance, MessageTypeEnum.contacts, result.vcardContact);
        } else if (result.place) {
          this.replyLocation(this.attendance, MessageTypeEnum.location, result.place);
        } else {
          const messageFg = this.formGroup.get('message');
          const newContent = UtilHelper.replaceIdentifiers(
            result.message,
            this.attendance,
            super.getNameCompanyCurrentUser(),
            super.getNameCurrentUser()
          );

          if (result.midia || result.midia === 'N/A') {
            const mediaType = this.helperExtension(result.midia);
            const isCaptionSend = mediaType === 'image' || mediaType === 'video' || mediaType === 'document';

            if (isCaptionSend) {
              this.replyMedia(this.attendance, mediaType, result.midia, result.response.contentType, newContent);
            } else {
              this.replyMedia(this.attendance, mediaType, result.midia, result.response.contentType);
              setTimeout(() => {
                this.replyText(this.attendance, newContent);
              }, 700);
            }
          } else if (result?.buttonActions?.length > 0) {
            const newContent = UtilHelper.replaceIdentifiers(result.message, this.attendance, super.getNameCompanyCurrentUser(), super.getNameCurrentUser());
            this.replyButton(this.attendance, MessageTypeEnum.button, result?.title, result?.footer, result.buttonActions, newContent);
          } else {
            messageFg.setValue(newContent);
          }
        }
      }
    });
  }


  autoResizeTextArea(element: HTMLTextAreaElement, maxRows = 5, minRows = 1): void {
    if (!element) return;

    // Ensures it starts small
    element.rows = minRows;
    element.style.overflowY = 'hidden';

    // Reads the actual metrics of the element
    const cs = getComputedStyle(element);
    const lineHeight = parseFloat(cs.lineHeight) || 20;
    const borders = (parseFloat(cs.borderTopWidth) || 0) + (parseFloat(cs.borderBottomWidth) || 0);
    const paddings = (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.paddingBottom) || 0);

    const maxHeight = Math.round(maxRows * lineHeight + paddings + borders);

    // Recalculates the height based on the content
    element.style.height = 'auto';
    const needed = element.scrollHeight; // height needed for the content
    element.style.height = Math.min(needed, maxHeight) + 'px';

    // Shows scroll only when exceeding the limit
    element.style.overflowY = needed > maxHeight ? 'auto' : 'hidden';
  }

  /*********************************************************************************
   ***************************** Whisper field *************************************
   *********************************************************************************/

  toggleWhisperField(): void {
    if (this.whisperFieldOpen) {
      this.closeWhisperField();
    } else {
      this.whisperReplyTo = null;
      this.whisperEditing = null;
      this.whisperFieldOpen = true;
    }
  }

  closeWhisperField(): void {
    this.whisperFieldOpen = false;
    this.whisperReplyTo = null;
    this.whisperEditing = null;
  }

  startWhisperReply(whisper: AttendanceWhisper): void {
    this.whisperEditing = null;
    this.whisperReplyTo = whisper;
    this.whisperFieldOpen = true;
  }

  startWhisperEdit(whisper: AttendanceWhisper): void {
    this.whisperReplyTo = null;
    this.whisperEditing = whisper;
    this.whisperFieldOpen = true;
  }

  // Opening a conversation with a whisper waiting for me marks it seen and clears the list indicator (RF-11).
  private async markWhisperSeen(idAttendance: string): Promise<void> {
    const pending = await firstValueFrom(this.whisperPending$);
    if (!pending?.includes(idAttendance)) {
      return;
    }
    this.whisperService.markSeen(idAttendance)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.store.dispatch(removeWhisperPending({ idAttendance })));
  }

  /*********************************************************************************
   ***************************** Socket Methods - init *****************************
   *********************************************************************************/

  private messagesQueue$ = new Subject<Message>();
  private attendanceQueue$ = new Subject<Attendance>();
  private socketConnectedStatus$ = new Subject<boolean>();

  private setupMessageQueue() {
    this.messagesQueue$.pipe(
      concatMap((newMessage) => {
        if (newMessage.attendance._id === this.attendance._id) {
          if (newMessage.edited === true) {
            this.store.dispatch(getMessages({ page: 1, perPage: this.pagerMessage.perPage, idAttendance: this.attendance._id, idCompany: super.getIDCurrentCompany() }));
          }
          const checkIfMessageIdExists = this.messages.find((message) => (message._id === newMessage._id));
          if (!checkIfMessageIdExists) {
            if (newMessage.type === MessageTypeEnum.reaction) {
              this.store.dispatch(getMessages({ page: 1, perPage: this.pagerMessage.perPage, idAttendance: this.attendance._id, idCompany: super.getIDCurrentCompany() }));
            } else {
              this.messages = [...this.messages, newMessage];
              // Bump only the copilot gate's live counter (separate field) — do NOT touch
              // state.messages, or this subscription would overwrite the optimistic append.
              this.countMessageForCopilot();
            }
          }
        }
        return of(null);
      }),
      takeUntil(this.destroy$)
    ).subscribe();
  }

  private setupAttendanceQueue() {
    this.attendanceQueue$.pipe(
      concatMap((attendance) => {
        if (this.attendance?._id === attendance._id) {
          const isAttendance = super.isAttendant();
          const isUserLogged = super.getIDCurrentUser();
          if (isAttendance && attendance.user?._id !== isUserLogged) {
            this.attendance = null;
            this.alertService.info(this.t('attendance.chat.attendanceTransferredToAnother'));
          } else {
            this.attendance = attendance;
          }
        }
        return of(null);
      }),
      takeUntil(this.destroy$)
    ).subscribe();
  }

  /**
   * Only to refresh messages when socket reconnects
   */
  private setupConnectedStatus() {
    this.socketConnectedStatus$.pipe(
      concatMap((connected) => {
        if (connected) {
          this.store.dispatch(getMessages({
            page: 1,
            perPage: this.pagerMessage.perPage,
            idAttendance: this.attendance._id,
            idCompany: super.getIDCurrentCompany()
          }));
          this.store.dispatch(getWhispers({ idAttendance: this.attendance._id }));
        }
        return of(null);
      }),
      takeUntil(this.destroy$)
    ).subscribe();
  }

  private configSocket(): void {
    if (!!this.attendance) {
      const code = super.getCodeCompanyCurrentUser();
      const idAttendance = this.attendance._id;
      const phone = this.attendance.contact.phone;

      this.setupAttendanceQueue();
      this.setupMessageQueue();
      this.setupConnectedStatus();

      const snameAttendance = `event_attendance_${code}_${this.attendance._id}`;
      this.socketService.joinEvent(snameAttendance);
      this.socketService.listen(snameAttendance)
        .pipe(takeUntil(this.destroy$))
        .subscribe((attendance: Attendance) => this.attendanceQueue$.next(attendance));

      const snameMessage = `event_message_${code}_${phone}_${idAttendance}`;
      this.socketService.joinEvent(snameMessage);
      this.socketService.listen(snameMessage)
        .pipe(takeUntil(this.destroy$))
        .subscribe((message: Message) => this.messagesQueue$.next(message));

      // Content-free whisper signal on the attendance room (ADR-002): refetch, never trust the payload.
      // The socket stays in the rooms of earlier conversations, so the id is checked.
      this.socketService.listen(WHISPER_SOCKET_EVENT)
        .pipe(takeUntil(this.destroy$))
        .subscribe((signal: AttendanceWhisperSignal) => {
          if (signal?.attendanceId === this.attendance?._id) {
            this.store.dispatch(getWhispers({ idAttendance: this.attendance._id }));
          }
        });

      this.socketService.getConnectedStatus()
        .pipe(takeUntil(this.destroy$))
        .subscribe((connected: boolean) => this.socketConnectedStatus$.next(connected));
    }
  }

  /*********************************************************************************
   ***************************** Socket Methods - end  *****************************
   *********************************************************************************/

}
